export default __webpack_public_path__ + "static/media/450.7418b3ea.png";